import axios from "axios";
import { ElMessage } from "element-plus";
import { imageLink } from "./image";

export const downloadFile = (url: string, filename: string = "下载.png") => {
  axios({
    method: "get",
    url: url,
    responseType: "blob",
  })
    .then((res) => {
      const disposition =
        res.headers?.["content-disposition"] ||
        (res.request as XMLHttpRequest)?.getResponseHeader?.(
          "Content-Disposition",
        ) ||
        "";
      console.log("disposition", disposition);
      const match = disposition.match(
        /filename\*?=(?:UTF-8'')?["']?(.+?)["']?(?:;|$)/i,
      );
      const name = match
        ? decodeURIComponent(match[1].replace(/["']/g, ""))
        : filename;

      const blobUrl = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.setAttribute("style", "display: none");
      a.download = name;
      a.href = blobUrl;
      a.click();
      window.URL.revokeObjectURL(blobUrl);
      a.remove();
    })
    .catch(() => {
      ElMessage.warning("下载失败");
    });
};

export const fileType = {
  jpg: "image",
  jpeg: "image",
  png: "image",
  gif: "image",
  svg: "image",
  tiff: "image",
  webp: "image",
  bmp: "image",
  heic: "image",
  ppt: "ppt",
  pptx: "ppt",
  doc: "word",
  docx: "word",
  xls: "excel",
  xlsx: "excel",
  pdf: "pdf",
  txt: "txt",
};

export const typeIcon = {
  image: imageLink.iconFileImage,
  excel: imageLink.iconFileExcel,
  pdf: imageLink.iconFilePdf,
  ppt: imageLink.iconFilePpt,
  txt: imageLink.iconFileTxt,
  word: imageLink.iconFileWrod,
  other: imageLink.iconFileOther,
};

export const getSizeUnit = (size: number) => {
  if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)}K`;
  }
  if (size < 1024 * 1024 * 1024) {
    return `${(size / 1024 / 1024).toFixed(2)}M`;
  }
  return `${(size / 1024 / 1024 / 1024).toFixed(2)}G`;
};

export const getFileType = (url: string) => {
  const ext = url.slice(url.lastIndexOf(".") + 1);
  return fileType[(ext || "").toLocaleLowerCase()] || "other";
};

// 获取音频信息
export const getAudioInfo = async (url: string) => {
  const audio = new Audio(url);
  return new Promise<any>((resolve) => {
    audio.addEventListener("loadedmetadata", () => {
      resolve({
        duration: audio.duration,
      });
    });
  });
};

// 获取视频信息
export const getVideoInfo = async (url: string) => {
  return new Promise<any>((resolve) => {
    const video = document.createElement("video"); // 创建一个视频元素，用于接收读取到的文件内容
    video.src = url;
    video.onloadedmetadata = () => {
      resolve({
        duration: video.duration,
        videoWidth: video.videoWidth,
        videoHeight: video.videoHeight,
      });
    };
  });
};

export const formatDuration = (duration: number) => {
  const s = duration;
  const t = parseInt(String(s / 60));
  const a = parseInt(String(s % 60));
  return (t < 10 ? "0" + t : t) + ":" + (a < 10 ? "0" + a : a);
};

// 更简洁的版本（使用fetch API，现代浏览器支持）
export function downloadBase64ImageSimple(
  base64,
  fileName = "image",
  imageType = "png",
) {
  try {
    // 处理base64字符串
    const base64Data = base64.startsWith("data:")
      ? base64
      : `data:image/${imageType};base64,${base64}`;

    // 使用fetch获取blob
    fetch(base64Data)
      .then((res) => res.blob())
      .then((blob) => {
        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.${imageType.split("/").pop() || "png"}`;

        // 触发下载
        link.click();

        // 清理资源
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);
      })
      .catch((error) => {
        console.error("下载Base64图片时出错:", error);
      });

    return true;
  } catch (error) {
    console.error("下载Base64图片时出错:", error);
    return false;
  }
}
